import { Component, Input } from "@angular/core";

@Component({
  selector: "app-icon-facebook-material",
  imports: [],
  templateUrl: "./icon-facebook-material.component.html",
  styleUrl: "./icon-facebook-material.component.scss",
})
export class IconFacebookMaterialComponent {
  @Input() color = "#fff";
}
